import React, { Fragment, useContext } from 'react';
import styled, { css } from "styled-components";
import Bg from "./Bg";
import Colorer from 'color';
import { Scrollbars } from 'react-custom-scrollbars';
import { ProductContext } from "../context";
// import {CssH1, CssMenu, CssMenuBorder, CloseButton, CssPop0, CssPopZ, CssPopBodyBorder, CssPopBodyBg, CssPopBody, CssPopInner, CssPopSections} from './UserAccount'

export default function Popup({
  fullscreen,
  title,
  footer, //TODO: popup footer
  sb,
  // theme = {
  //   backgroundUrl: "https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg",
  //   borderRadius:
  //   8,
  //   boxShadow: "0 5px 12px 0px rgba(0,0,0,0.2)",
  //   cardWidth: "300",
  //   colorText: "#00FF00",
  //   colorAccent: "#FFFF00",
  //   colorAccentText: "#000",
  //   colorBg: "#050c27",
  //   fontFamily: "'Roboto','Helvetica Neue',Arial,'Noto Sans',sans-serif",
  //   padding: "8px",
  //   transition: "all 0.3s ease-in-out",
  //   transitionEasing: "ease-in-out",
  //   transitionStyle: "0.3s ease-in-out",
  //   transitionTime: "0.3s",
  // },
  children,
  handleClose,
}) {


//  console.log('typeof title = ', typeof title);

const valueFromContext = useContext(ProductContext);

  let theme = valueFromContext['theme']


  return (
    <CssPop0
      sb={sb}
      theme={theme}
    >

      <CssPopZ
        onClick={()=>{handleClose && handleClose()}}
        theme={theme}
      />


    <CssPopBody theme={theme} fullscreen={fullscreen}>



    <CssPopBodyBg>
        <Bg
          style={{opacity: 0.4}}
          absolute
          effect
        />
    </CssPopBodyBg>

    <CssPopInner>
      <Fragment>


        <CssMenu>
          <CssMenuBorder theme={theme}/>
          {typeof title === 'string' && title}
          {typeof title === 'undefined' && <div></div>}
          {typeof title === 'function' && title()}
          {handleClose && <CloseButton
            handler={()=>{handleClose()}}
            theme={theme}
          />}
        </CssMenu>

        <CssPopSections>
          <CssPopupBody>
            {children}
          </CssPopupBody>
        </CssPopSections>

      </Fragment>

      </CssPopInner>

      <CssPopBodyBorder theme={theme} fullscreen={fullscreen}/>

    </CssPopBody>

  </CssPop0>
  )
}





export const CloseButton = ({
  handler = ()=>{void(0)},
  theme,
}) => {
  return (<div style={{display: 'flex', justifyContent: 'flex-end', flexGrow: 1}}>
      <CssClose
        onClick={handler}
        theme={theme}
      >
        <div style={{display: 'flex', alignItems: 'stretch', justifyContent: 'stretch'}}>
          <svg viewBox="0 0 32 32" width={24} height={24} xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" fill='currentColor' clipRule="evenodd" d="M16 17.414l-6.384 6.384a.8.8 0 0 1-1.131 0l-.283-.283a.8.8 0 0 1 0-1.13L14.586 16 8.202 9.616a.8.8 0 0 1 0-1.131l.283-.283a.8.8 0 0 1 1.131 0L16 14.586l6.384-6.384a.8.8 0 0 1 1.132 0l.282.283a.8.8 0 0 1 0 1.13L17.414 16l6.384 6.384a.8.8 0 0 1 0 1.131l-.282.283a.8.8 0 0 1-1.132 0L16 17.414z" />
          </svg>
        </div>
      </CssClose>
    </div>
  )
}






const CssPopupBody = styled.div`
  font-size: 14px;
  padding: 30px 0 30px 0;
`


export const CssPop0 = styled.div`
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 11;
  top: 0px;
  bottom: 0px;
  left: ${({sb}) => sb ? '320px' : '0px'};
  right: 0px;

  @media (max-width: 991px) {
    left: ${({sb}) => sb ? '320px' : '0px'};
  }

  @media (max-width: 767px) {
    left: 0 !important;
  }

  @media (max-width: 479px) {
    left: 0 !important;
  }

`




export const CssMenuBorder = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  border-bottom: 1px solid ${({theme}) => Colorer(theme.colorText).alpha(0.2).string()};
  z-index: 0;
`

export const CssMenu = styled.div`
  top: 0;
  /* width: 712px; */
  min-height: 80px;
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  /* margin-bottom: 29px; */
  position: relative;

  &>ul{
    list-style: none;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: row;
    padding: 0;
    height: 80px;
    margin: 0;
    position: relative;
    z-index: 2;
  }
`




const CssClose = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  border-radius: 100%;
  cursor: pointer;
  background-color: ${({theme}) => {
    return Colorer(theme['colorText']).alpha(0.1).string()
  }};
  transition: background-color 150ms ease-in-out 0s;
  & svg {
    transition: background-color 150ms ease-in-out 0s;
    opacity: 0.4;
    fill: ${({theme}) => {
      return Colorer(theme['colorText']).alpha(0.1).string()
    }}
  }
  &:hover {
    background-color: ${({theme}) => {
      return Colorer(theme['colorText']).alpha(0.2).string()
    }};
  }
  &:hover svg {
    opacity: 1
  }
`









export const CssPopZ = styled.div`
  position: absolute;
  z-index: 0;
  top: 0;
  bottom: 0;
  opacity: 0.6;
  left: 0;
  right: 0;
  background-color: ${({theme}) => {
    let colorBg;
    if (Colorer(theme.colorBg).luminosity() < 0.12) {
      colorBg = 'white'
    } else {
      colorBg = 'black'
    }
    return colorBg;
  }};
`
export const CssPopBodyBorder = styled.div`

  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  ${({fullscreen}) => !fullscreen && css`
      border-radius: ${({theme})=>
        theme.borderRadius > 16 ? 16 : theme.borderRadius
      }px;
    `
  };
  box-shadow: inset 0px 0px 1px 1px ${({theme}) => Colorer(theme.colorText).alpha(0.1).string()};
  z-index: 0;
  user-select: none;
  pointer-events: none !important;
`

export const CssPopBodyBg = styled.div`
  /* filter: blur(30px); */
  /* background-image: url(${({theme}) => theme['backgroundUrl']}); */
  /* transform: scale(1.2); */
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
`


export const CssPopInner = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  height: 100%;
  flex-direction: column;
`
export const CssPopSections = styled(Scrollbars)`
  flex-grow: 1;
  /* overflow: auto; */
  -webkit-overflow-scrolling: touch;
  margin-bottom: -16px;

  /* font-size: 12px; */
`



export const CssPopBody = styled.div`
  font-size: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  ${({fullscreen}) => !fullscreen && css`
      top: 10vh;
      bottom: 10vh;
      height: 80vh;
      max-width: 960px;
      border-radius: ${({theme})=>
        theme.borderRadius > 16 ? 16 : theme.borderRadius
      }px;
    `
  };
  ${({fullscreen}) => fullscreen && css`
      height: 100vh;
    `
  };

  position: relative;
  z-index: 100;
  width: 100%;
  color: ${({theme})=>theme.colorText};
  background-color: ${({theme}) => {
    let colorBg;
    if (Colorer(theme.colorBg).luminosity() < 0.0065) {
      colorBg = Colorer(theme.colorBg).blacken(0.3).desaturate(0.4).negate().hex()
    } else {
      colorBg = Colorer(theme.colorBg).desaturate(0.4).hex()
    }
    return colorBg;
  }};


  padding: 0 32px 0px 32px;
  min-height: 420px;
  transition: all 250ms ease-in-out;
  box-shadow:  ${({theme}) => {
    return Colorer(theme.colorBg).luminosity() < 0.0065 ?
    'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.8)'
  }};

  @media (max-width: 991px) {
    top: 0;
    bottom: 0;
    height: 100vh;
    border-radius: 0px;
  }

  @media (max-width: 767px) {

  }

  @media (max-width: 479px) {

  }

`
